import {Item} from '@hconnect/common/Invite/Create/components/LookupDropdown'
import {ErrorPaper, SelectDropdown} from '@hconnect/uikit'
import {Box} from '@mui/material'
import React from 'react'
import {Controller} from 'react-hook-form'

import {Option} from '../../../common/AutoSelectDropdown'
import {useTranslation} from '../../../hooks/useTranslation'
import {useWidgetUserCreationStyles} from '../WidgetUserCreation.styles'

import {WidgetInputsProps} from './WidgetInputs.types'

type WidgetDispatchPhoneKeyInputProps = WidgetInputsProps & {
  primaryOrgUnitsMarketsSelectValues: Option[]
}

export const WidgetDispatchPhoneKeyInput = ({
  formMethods,
  primaryOrgUnitsMarketsSelectValues
}: WidgetDispatchPhoneKeyInputProps) => {
  const {t} = useTranslation()
  const {classes} = useWidgetUserCreationStyles()

  return (
    <Controller
      name="dispatchPhoneKey"
      control={formMethods.control}
      render={({field}) => (
        <SelectDropdown
          {...field}
          showSearch={false}
          disabled={!formMethods.watch().country}
          data-test-id="widget-dispatchPhoneKey-dropdown"
          label={t('widgetUserCreation.form.dispatchPhoneKey')}
          className={classes.selectDropdown}
          errorRender={() => <ErrorPaper variant="primaryDark" />}
          selectedProps={{style: {fontWeight: 400}}}
          showError={false}
          options={primaryOrgUnitsMarketsSelectValues}
          renderItem={(item: Item) => (
            <Box style={{display: 'flex', flexDirection: 'column'}}>
              <Box>{item.label}</Box>
              <Box>{item.value}</Box>
            </Box>
          )}
          stringifyItem={(item: Item) => item.value}
          renderChosenItem={(item: Item) => item.label}
          selectedItem={{
            label:
              primaryOrgUnitsMarketsSelectValues?.find((option) => option.value === field.value)
                ?.label || '',
            value:
              primaryOrgUnitsMarketsSelectValues?.find((option) => option.value === field.value)
                ?.value || ' '
          }}
          popoverStyle={{left: 0}}
          onChange={(item) => {
            field.onChange(item.value)
          }}
        />
      )}
    />
  )
}
